import { SharedState } from '@trello/shared-state';

type WorkspaceStateStatus = 'INITIALIZING' | 'LOADING' | 'ERROR' | 'READY';
type WorkspaceStateError = 'NO_MATCHING_ROUTE';

export interface WorkspaceState {
  status: WorkspaceStateStatus;
  error: WorkspaceStateError | null;
  idWorkspace: string | null;
  isGlobal: boolean;
}

export const workspaceState = new SharedState<WorkspaceState>({
  status: 'INITIALIZING',
  error: null,
  idWorkspace: null,
  isGlobal: false,
});
